/*
【仕様変更】施設予約抽選期間の開始をラベルで1固定に変更
　※再度戻す場合に備えて仕様変更前の内容をコメントアウト
 */
import React, {Component, ReactElement} from 'react'

import NatCondominiumRepo from './repository/NatCondominiumRepo'
import NatCondominiumGroupRepo from '../condominiumGroup/repository/NatCondominiumGroupRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import NatUseFunctionMasterRepo from '../useFunctionMaster/repository/NatUseFunctionMasterRepo'
import {Messages} from '../../../Messages'
import {NatPostCondominium, NatPostCondominiumParams} from './repository/NatPostCondominium'
import {MESSAGE_TYPE} from '../../../CodeMaster'
import {NatAdminCondominiumForm} from './NatAdminCondominiumForm'
import {NatGetUseFunctionMaster, UseFunctionMaster} from '../useFunctionMaster/repository/NatGetUseFunctionMaster'
import {CondominiumGroupData, NatGetCondominiumGroup} from '../condominiumGroup/repository/NatGetCondominiumGroup'
import {Location} from 'react-router-dom'

interface Props {
    condominiumRepo: NatCondominiumRepo
    condominiumGroupRepo: NatCondominiumGroupRepo
    useFunctionMasterRepo: NatUseFunctionMasterRepo
    eventEmitter: EventEmitterExAdmin
    location: Location
}

interface States {
    isLoadCompleted: boolean
    condominiumGroup: CondominiumGroupData
    useFunctionMaster: UseFunctionMaster[]
}

class NatAdminCondominiumRegisterPage extends Component<Props & AdminPagePropsSet, States> {

    constructor(props: Props & AdminPagePropsSet) {
        super(props)

        this.state = {
            isLoadCompleted: false,
            condominiumGroup: {
                level1CondominiumGroupId: '',
                level1CondominiumGroupName: '',
                level1CondominiumGroupVersion: 0,
                level2CondominiumGroupInfo: [],
            },
            useFunctionMaster: [],
        }

        this.registerCondominiumButton = this.registerCondominiumButton.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.condominiumListLinkClick = this.condominiumListLinkClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()

        try {

            // 物件グループマスタ一覧取得
            const condominiumGroupResponse: Nullable<NatGetCondominiumGroup> = await this.props.asyncCallFunction(
                this.props.condominiumGroupRepo.getCondominiumGroup.bind(this.props.condominiumGroupRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (condominiumGroupResponse && condominiumGroupResponse.details) {
                this.setState({
                    condominiumGroup: condominiumGroupResponse.details,
                })
            }

            // 利用機能マスタ一覧取得
            const useFunctionMasterResponse: Nullable<NatGetUseFunctionMaster> = await this.props.asyncCallFunction(
                this.props.useFunctionMasterRepo.getUseFunctionMaster.bind(this.props.useFunctionMasterRepo),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
            )
            if (useFunctionMasterResponse && useFunctionMasterResponse.details) {
                this.setState({
                    useFunctionMaster: useFunctionMasterResponse.details,
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }

    }

    // 登録ボタン押下
    async registerCondominiumButton(condominium: NatPostCondominiumParams): Promise<void> {

        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString(condominium.condominiumName),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: () => this.handleRegisterOkClick(condominium),
                    },
                ],
            },
        )
    }

    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(registerCondominiumParams: NatPostCondominiumParams): Promise<void> {
        this.props.eventEmitter.closeDialog()
        this.props.eventEmitter.clearBroadcastedErrors()
        await this.props.eventEmitter.showLoading()

        try {
            const registerCondominiumResponse: Nullable<NatPostCondominium> = await this.props.asyncCallFunction(
                this.props.condominiumRepo.postCondominium.bind(this.props.condominiumRepo, registerCondominiumParams),
                async (httpErrorOrNetworkError) => {
                    await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                },
                {defaultErrorTitle: Messages.EOPCA0001.toString('物件')},
            )
            if (registerCondominiumResponse &&
                registerCondominiumResponse.details &&
                registerCondominiumResponse.requestError === null) {
                this.props.navigate(
                    `/admin/condominium/${registerCondominiumResponse.details.condominiumCd}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0004.toString('物件', registerCondominiumParams.condominiumName),
                            },
                        },
                    },
                )
            } else {
                return
            }

        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    condominiumListLinkClick(): void {
        this.props.navigate(
            '/admin/condominiumList/',
        )
    }

    render(): ReactElement {
        if (!this.state.isLoadCompleted) {
            return (<></>)
        }
        return <>
            <NatAdminCondominiumForm
                mode={'register'}
                condominiumGroup={this.state.condominiumGroup}
                useFunctionMaster={this.state.useFunctionMaster}
                condominiumRepo={this.props.condominiumRepo}
                eventEmitter={this.props.eventEmitter}
                onRegisterCondominium={this.registerCondominiumButton}
                backButtonText={'物件検索へ戻る'}
                onBack={this.condominiumListLinkClick}
            />
        </>
    }
}

export default createAdminPage(NatAdminCondominiumRegisterPage)
